import { render, staticRenderFns } from "./SpecialFeatures.vue?vue&type=template&id=3a0c9ed6"
import script from "./SpecialFeatures.vue?vue&type=script&lang=ts"
export * from "./SpecialFeatures.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports